import axios from "axios";
import { useRef } from "react";

import { getSessionToken } from "utils/session";

const ORQUESTRADOR_AGENTES_BASE_URL =
  "https://apis.mixfiscal.com.br/orquestrador-agentes/v1";

// Instância axios do orquestrador-agentes. As rotas liberadas ao painel
// (@AllowPanelUser no backend) aceitam o JWT de sessão do usuário logado.
export const useApiOrquestradorAgentes = () => {
  const apiRef = useRef(null);

  if (!apiRef.current) {
    apiRef.current = axios.create({ baseURL: ORQUESTRADOR_AGENTES_BASE_URL });

    apiRef.current.interceptors.request.use(config => {
      const token = getSessionToken();
      config.headers.Authorization = token?.startsWith("Bearer ")
        ? token
        : `Bearer ${token}`;
      return config;
    });
  }

  return apiRef.current;
};
